import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
// local
import CustomCollapse from "components/CustomCollapse";
import {
  IconUploadContractSheet,
  IconFeather,
  IconLock,
  IconHourglass,
} from "components/icons";
import {
  toRequestId,
  toContractId,
  toSignContractId,
  toUploadedContractId,
} from "constants/routes.const";
import {color} from "constants/color.consts";
import {contractType, contractStatus} from "constants/buyer.consts";
import cn from "classnames";

const iconProps = {color: color.blue};

const rftStatusIcon = {
  [contractStatus.RFT_PENDING]: <IconHourglass {...iconProps} />,
  [contractStatus.RFT_COMPLETED]: <IconLock />,
};

const getIcon = (type, status) => {
  if (type === contractType.RFT) return rftStatusIcon[status];
  if (type === contractType.UPLOADED) return <IconUploadContractSheet {...iconProps} />;
  if (type === contractType.HANDYSIGN) return <IconFeather {...iconProps} />;
};

const ConnectedContracts = ({contracts, title, subLevel, addClass}) => {
  const {t} = useTranslation();
  const [isShowContracts, setIsShowContracts] = useState(false);

  if (!contracts?.length) return null;

  const ContractRow = ({contract}) => {
    const navigate = useNavigate();
    const {id, type, status, name, counterpartyCompanyName, Supplier, supplierName} =
      contract;

    const handleClick = () => {
      if (type === contractType.RFT_PENDING) navigate(toRequestId(id));
      if (type === contractType.RFT_COMPLETED) navigate(toContractId(id));
      if (type === contractType.UPLOADED) navigate(toUploadedContractId(id));
      if (type === contractType.HANDYSIGN) navigate(toSignContractId(id));
    };

    const supplier = Supplier?.Company?.companyName || Supplier?.name || supplierName;
    const label = counterpartyCompanyName || supplier || t(name) || "--";

    return (
      <div
        className={cn("connected-contracts__row", {"pr-[108]": !!subLevel})}
        onClick={handleClick}
      >
        <div className="blue fg2">{label}</div>
        {getIcon(type, status)}
      </div>
    );
  };

  return (
    <div
      className={cn("connected-contracts", {
        [addClass]: !!addClass,
        "pt-5": !!subLevel,
        "pb-2": !isShowContracts && !!subLevel,
        "pb-3": !isShowContracts && !subLevel,
      })}
    >
      <CustomCollapse
        small
        title={
          <span className="pl-1 fz-12 __bold __uppercase discrete-text">
            {t(title ?? "CONNECTED_CONTRACTS")}
            <span className="ml-2">{contracts.length}</span>
          </span>
        }
        noTranslate
        addClass="__no-divider fz-12 __bold __uppercase discrete-text"
        isActive={isShowContracts}
        onChange={() => setIsShowContracts((prev) => !prev)}
      />
      {isShowContracts &&
        contracts.map((contract) => (
          <ContractRow key={contract.id} contract={contract} />
        ))}
    </div>
  );
};

export default ConnectedContracts;
